import { Link } from "@tanstack/react-router";
import { LayoutGrid } from "lucide-react";
import type { FacetCounts } from "@/lib/skills/catalog";
import { ALL_CATEGORIES } from "@/lib/skills/categories";
import { categoryMeta } from "@/lib/skills/constants";

const CARD_CLASS =
  "flex items-center gap-3.5 rounded-[13px] border border-border-1 bg-white p-[18px] text-left transition-[transform,box-shadow,border-color] duration-200 hover:-translate-y-[3px] hover:border-border-2 hover:shadow-md";

export function BrowseCategories({ counts, total }: { counts: FacetCounts; total: number }) {
  return (
    <section>
      <h2 className="mb-3 font-display text-[19px] font-bold tracking-tight text-navy">
        Browse by category
      </h2>
      <div className="grid gap-3.5 [grid-template-columns:repeat(auto-fill,minmax(220px,1fr))]">
        {ALL_CATEGORIES.map((c) => {
          const meta = categoryMeta(c);
          const Icon = meta.icon;
          const n = counts.category[c];
          return (
            <Link key={c} to="/skills" search={{ cat: c }} className={CARD_CLASS}>
              <span
                className="grid size-[46px] shrink-0 place-items-center rounded-[12px]"
                style={{ backgroundColor: meta.bg, color: meta.fg }}
              >
                <Icon className="size-[23px]" />
              </span>
              <div>
                <h3 className="font-display text-base font-bold text-navy">{c}</h3>
                <p className="mt-0.5 text-[12.5px] text-fg-3">
                  {n} skill{n !== 1 ? "s" : ""}
                </p>
              </div>
            </Link>
          );
        })}
        <Link to="/skills" className={CARD_CLASS}>
          <span className="grid size-[46px] shrink-0 place-items-center rounded-[12px] bg-bg-3 text-navy">
            <LayoutGrid className="size-[23px]" />
          </span>
          <div>
            <h3 className="font-display text-base font-bold text-navy">All skills</h3>
            <p className="mt-0.5 text-[12.5px] text-fg-3">{total} in the library</p>
          </div>
        </Link>
      </div>
    </section>
  );
}
